import OrganizationConfiguration from './OrganizationConfiguration'
export default OrganizationConfiguration
